import type { SimulatorSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { button } from 'components/Editor/styled/Button'
import type { ElementStyleCss } from 'services/Branding/types'

const CloseIconStyled = styled.button<{
  $styles: ElementStyleCss<SimulatorSchemaType>
}>`
  ${button}
  position: absolute;
  display: flex;
  top: 8px;
  right: 8px;
  justify-content: flex-end;
  z-index: 1000;
  width: 20px;
  height: 20px;
  background-image: ${({ $styles }) => $styles.hint?.backgroundImage};
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  font-size: 24px;
  cursor: pointer;
`

export default CloseIconStyled
